import React, { useEffect, useRef } from "react";

import "../../styles/components/MapContainer.css";
import MapInteractionLayer from "./MapInteractionLayer";
import MapOverlayCoordinator from "./MapOverlayCoordinator";
import useMapContainerState from "./useMapContainerState";

export default function MapContainer(props) {
  const map = useMapContainerState(props);
  const {
    onCatchMarkerDetailsOpenChange,
    onFishingOutlookContextChange,
    onLocateMeHandlerChange,
  } = props;
  const hasReportedMapSelectionRef = useRef(false);
  const isCatchMarkerDetailsOpen = Boolean(map.selectedSpot);

  useEffect(() => {
    onLocateMeHandlerChange?.(map.handleLocateMe);
    return () => onLocateMeHandlerChange?.(null);
  }, [map.handleLocateMe, onLocateMeHandlerChange]);

  useEffect(() => {
    onCatchMarkerDetailsOpenChange?.(isCatchMarkerDetailsOpen);
  }, [isCatchMarkerDetailsOpen, onCatchMarkerDetailsOpenChange]);

  useEffect(() => {
    if (!hasReportedMapSelectionRef.current) {
      hasReportedMapSelectionRef.current = true;
      return;
    }
    onFishingOutlookContextChange?.(
      map.selectedSpot?.privateFavoriteOutlookContext || null
    );
  }, [map.selectedSpot, onFishingOutlookContextChange]);

  useEffect(
    () => () => onCatchMarkerDetailsOpenChange?.(false),
    [onCatchMarkerDetailsOpenChange]
  );

  return (
    <div className="map-root">
      <MapInteractionLayer map={map} />
      <MapOverlayCoordinator map={map} />
    </div>
  );
}
